import { inject, Provider } from '@angular/core';
import { REPLAY_SITE_BUILDING } from '@wheere-front/domain-trackers';
import { SiteModelClient } from '../data/site-model.client';
import { ReplaySiteBuildingState } from './replay-site-building';
import { SiteBuildingControlsComponent } from './site-building-controls.component';

/** Active le bâtiment 3D sur la carte de rejeu des positions (inside seulement, ADR-017). */
export function provideReplaySiteBuilding(): Provider {
  return {
    provide: REPLAY_SITE_BUILDING,
    useFactory: () => {
      const client = inject(SiteModelClient);
      return { create: () => new ReplaySiteBuildingState(client), controls: SiteBuildingControlsComponent };
    },
  };
}
